// getters.js

export default {
    getBrandList(state){
        return state.brandList
    },
};
